import { PermissionRoute } from '@anytag/app';
import { adminRoles } from '@anytag/shared-constants';
import { PartialRouter } from '../../types';
import { Prompts } from '../../../pages';

export const PromptsRouter = {
  '/_private-routes/prompts/': [() => <PermissionRoute permissions={adminRoles} element={<Prompts />} />, {}] as const
} as const satisfies PartialRouter;
